import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Tooltip } from "@mui/material";
import {
  DeleteIcon,
  EditIcon,
  HistoryIcon,
  PastHistoryInvestigations,
  PastHistoryMedication,
} from "./EmrCommonAsset/Asset";
// import OPDRadiologyModal from "./RadiologyModal";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import { useEMRGeneralContext } from "../newGeneralEmr/EMRContextGeneral";
import {
  DeleteService,
  getInvestigationList,
} from "../services/EMRServices/emrServices";
import PastRadiology from "./PastRadiology";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { useFormContext } from "react-hook-form";
import { warningAlert } from "../../../common/components/Toasts/CustomToasts";
import { successAlert } from "../../../common/components/Toasts/CustomToasts";
export default function Radiology(props) {
  const {
    radiologyData,
    setRadiologyData,
    dataRadiology,
    setDataRadiology,
    serviceData,
    setServiceData,
    markFavoriteData,
    patientHistoryData,
    setPatientHistoryData,
  } = props;
  const [investigationChipsList, setInvestigationChipsList] = useState([]);
  const [investigationList, setInvestigationList] = useState([]);
  const [selectedRadiology, setSelectedRadiology] = useState(null);
  const [chipsCount, setChipsCount] = useState(5);
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [selectedChips, setSelectedChips] = useState([]);
  const [openRadiologyModal, setOpenRadiologyModal] = useState(false);
  const [data, setData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [row, setRow] = useState();
  const [index, setIndex] = useState();
  const [editOpen, setEditOpen] = useState(false);
  const [save, setSave] = useState(false);
  const [openPastRadiology, setOpenPastRadiology] = useState(false);
  const [isDeletedData, setIsDeletedData] = useState([]);
  const [investigationption, setInvestigationOption] = useState([]);
  const [id, setId] = useState(null);
  let userRole = JSON.parse(localStorage.getItem("loggedUser"));
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });
  // useEffect(() => {
  //   if (openRadiologyModal === false) {

  //     let radiologyObj = {
  //       testTypeId: 2,
  //       departmentId: props.patientVisitedDepartmentId,
  //       searchString: null,
  //       unitId: userRole.loginUnitId,
  //     };
  //     getInvestigationList(radiologyObj)
  //       .then((response) => {
  //         setInvestigationChipsList(response.data.result);
  //         setInvestigationList(response.data.result);
  //       })
  //       .catch((response) => {
  //         console.log(response);
  //       });
  //   }
  // }, []);
  const DeleteRecord = (Id) => {
    DeleteService(Id).then((response) => {
      successAlert(response.data.result);
    });
  };

  function deleteRow(row, index) {
    const newComplaintsData = [...radiologyData];
    const removedItem = newComplaintsData.splice(index, 1)[0];
    setRadiologyData(newComplaintsData);
    setDataRadiology(newComplaintsData);

    let temp = [...serviceData];
    if (temp?.length > 0) {
      for (let s = 0; s < temp?.length; s++) {
        if (removedItem.serviceId === temp[s].serviceId) {
          temp.splice(s, 1);
          break; // exit the loop once the item is found and removed
        }
      }
    }
    setServiceData(temp);

    // Check if the new index is valid
    if (removedItem?.id !== null && removedItem.id !== undefined) {
      let deleteFlag = [...radiologyData];
      if (deleteFlag?.length > 0) {
        for (let i = 0; i < deleteFlag?.length; i++) {
          if (deleteFlag[i].serviceId === removedItem.serviceId) {
            deleteFlag[i].isDeleteFlag = true;
          }
        }
      }

      setIsDeletedData(deleteFlag);
    }
    if (removedItem?.id !== null && removedItem.id !== undefined) {
      let temArr = [...serviceData];
      if (temArr?.length > 0) {
        for (let i = 0; i < temArr?.length; i++) {
          if (temArr[i].serviceId === removedItem.serviceId) {
            temArr[i].isDeleteFlag = true;
          }
        }
      }

      setServiceData(temArr);
    }
    if (row.id !== null) {
      DeleteRecord(row.id);
    }
  }
  const mergeArray = (arr) => {
    return arr?.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.serviceId === val.serviceId);
      if (ind !== -1) {
        console.log("Service Already Exists");
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };
  useEffect(() => {
    // const combinedData2 = [...serviceData,...isDeletedData]

    const combinedData = [...radiologyData, ...isDeletedData];
    setRadiologyData(mergeArray(combinedData));

    // setServiceData(combinedData2)
  }, [isDeletedData]);

  const renderActions = (row, index) => {
    setId(row?.id);
    return (
      <div className="flex gap-2">
        {/* <Tooltip title="Edit">
          <button
            disabled={row?.id > 0}
            type="button"
            onClick={() => {
              setEditOpen(true);
              setEdit(true);
              setRow(row);
              setIndex(index);
            }}
          >
            <EditIcon />
          </button>
        </Tooltip> */}

        {!row?.isWorkOrderCreated === true && !row?.isBiled ? (
          <Tooltip title="Delete">
            <button
              disabled={row.orderId !== null && row.orderId !== undefined}
              type="button"
              onClick={() => {
                deleteRow(row, index);
              }}
            >
              <DeleteIcon />
            </button>
          </Tooltip>
        ) : (
          ""
        )}
      </div>
    );
  };

  // useEffect(() => {
  //   if (save === true) {
  //     // console.log("props.complaintsData", pathologyData);
  //     setRadiologyData([...dataRadiology]);
  //     setSave(false);

  //   }
  // }, [save]);
  function renderInput(row, index, header) {
    return (
      <>
        {header === "Urgent" && (
          <>
            <input
              // disabled
              type="checkbox"
              name={`urgent${index}`}
              checked={row.Urgent}
              onChange={(e) => {
                let tempData = [...radiologyData];
                tempData[index].urgent = e.target.checked;
                setRadiologyData(tempData);
              }}
            />
          </>
        )}
      </>
    );
  }

  const handleChange = (e) => {
    if (e !== undefined && e !== "") {
      let radiologyObj = {
        testTypeId: 2,
        departmentId: props.patientVisitedDepartmentId,
        searchString: e,
        unitId: userRole.loginUnitId,
      };
      getInvestigationList(radiologyObj)
        .then((response) => {
          setInvestigationOption(response.data.result);
        })
        .catch((response) => {
          console.log(response);
        });
    } else if (e === "" || e === undefined || e === null) {
      setInvestigationOption([]);
    }
  };
  let radiology = watch("radiology");

  let urgent = watch("urgent");
  useEffect(() => {
    if (radiology !== null && radiology !== undefined) {
      let obj = {
        testId: radiology?.id,
        service: radiology?.label,
        urgent: urgent,
        // id: id !== null ? id : null,
        serviceId: radiology?.serviceId,
        isNew: true,
        isLab: true,
        isDeleteFlag: false,
        isTempDelete: false,
      };
      let temp = radiologyData.some(
        (item) => item.service === radiology?.label
      );
      if (temp === true) {
        warningAlert("Already Present Record..!");
      } else {
        // if (investigation !== null && investigation !== undefined) {
        setRadiologyData((prevState) => [...prevState, obj]);
        setServiceData((prevState) => mergeArray([...prevState, obj]));
        setValue("radiology", null);
        setValue("urgent", false);
        // } else {
        //   warningAlert("Please Fill The Record");
        // }
      }
    }
  }, [radiology]);
  const filteredPathologyData =
    radiologyData?.filter((item) => item.isDeleteFlag === false) || [];

  const mergeRadiologyArray = (arr) => {
    return arr.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.service === val.service);
      if (ind !== -1) {
        warningAlert("Service Already Exists");
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };
  return (
    <div>
      <div className="flex justify-between bg-[#DEFFD6] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-2">Radiology</p>
        <div className="flex w-[300px] my-auto gap-2">
          {/* <button
            type="button"
            onClick={() => {
              setOpenRadiologyModal(true);
            }}
          >
            <div className="flex justify-between border w-36 mx-2 bg-white">
              <p className="text-xs my-auto px-2">Radiology</p>
              <SearchIcon />
            </div>
          </button> */}
          <fieldset
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            className="w-full"
          >
            <SearchDropdown
              // ref={selectRef}
              focused={true}
              control={control}
              // error={errors.allergyType}
              name="radiology"
              label="Investigation"
              placeholder="Investigation"
              dataArray={investigationption}
              isSearchable={false}
              handleInputChange={handleChange}
              searchIcon={true}
              // onInputChange={handleChange}
              autoFocus
            />
          </fieldset>
          {/* <button
            type="button"
            onClick={() => {
              setOpenPastRadiology(true);
              // setSave(false)
            }}
          >
               <HistoryIcon/>
          </button> */}
        </div>
      </div>
      <div className=" border h-44 overflow-auto pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        <div className="flex justify-between ">
          <div className="flex flex-wrap space-x-2 pl-2">
            {markFavoriteData?.Radiology &&
              markFavoriteData?.Radiology.slice(0, chipsCount).map(
                (item, index) => {
                  const isSelected = selectedChips.includes(item);
                  return (
                    <div
                      key={index}
                      className={`mr-[5px] mb-1 capitalize h-[27px] px-3 w-max rounded text-sm border border-gray-300 whitespace-nowrap ${
                        radiologyData?.some(
                          (val) => val?.service === item.label
                        )
                          ? "bg-[#32819b] text-white rounded-full border"
                          : "text-black rounded-full border"
                      }`}
                      disabled={radiologyData.some(
                        (val) => val?.service === item.label
                      )}
                      onClick={() => {
                        // if (selectedChips.includes(item)) {
                        //   // setSelectedChips(
                        //   //   selectedChips.filter(
                        //   //     (selectedChip) => selectedChip !== item
                        //   //   )
                        //   // );
                        // } else {
                        //   setSelectedChips([...selectedChips, item]);
                        // }
                        setValue("radiology", item);
                        // setSelectedRadiology(item);
                        // setOpenRadiologyModal(true);
                      }}
                    >
                      {item.label}
                    </div>
                  );
                }
              )}
          </div>
        </div>

        {/* {checkDuplicate === true ? (
<p className="text-xs text-red-500"> Record Already Present</p>
) : (
""
)} */}

        <>
          {filteredPathologyData?.length > 0 ? (
            <div className="">
              <CommonTransactionTable
                dataResult={mergeRadiologyArray(filteredPathologyData).map(
                  (item) => ({
                    Investigation: item.service,
                    Urgent: item.urgent,
                    isLab: item.isLab,
                    isDeleteFlag: item?.isDeleteFlag,
                    testId: item?.testId,
                    id: item?.id,
                    serviceId: item?.serviceId,
                    status: item?.status,
                    isTempDelete: item?.isTempDelete,
                    isWorkOrderCreated: item?.isWorkOrderCreated,
                  })
                )}
                renderActions={renderActions}
                highlightRow={false}
                renderInput={renderInput}
                editableColumns={["Urgent"]}
                removeHeaders={[
                  "isLab",
                  "isDeleteFlag",
                  "testId",
                  "id",
                  "serviceId",
                  "status",
                  "isTempDelete",
                ]}
              />
            </div>
          ) : null}
        </>

        <div className="">
          {/* <OPDRadiologyModal
            radiologyData={radiologyData}
            setRadiologyData={setRadiologyData}
            dataRadiology={dataRadiology}
            setDataRadiology={setDataRadiology}
            serviceData={serviceData}
            setServiceData={setServiceData}
            openRadiologyModal={
              openRadiologyModal === true ? openRadiologyModal : editOpen
            }
            setOpenRadiologyModal={setOpenRadiologyModal}
            investigationChipsList={investigationChipsList}
            selectedRadiology={selectedRadiology}
            // selectedAllergieDecription={selectedAllergieDecription}
            // radiologyData={props.radiologyData}
            // setRadiologyData={props.setRadiologyData}
            setSelectedChips={setSelectedChips}
            selectedChips={selectedChips}
            data={data}
            setData={setData}
            setEditOpen={setEditOpen}
            edit={edit}
            setEdit={setEdit}
            row={row}
            index={index}
            departmentId={props.patientVisitedDepartmentId}
            setSave={setSave}
          /> */}
        </div>
        <div>
          <PastRadiology
            patientHistoryData={patientHistoryData}
            setPatientHistoryData={setPatientHistoryData}
            openPastRadiology={openPastRadiology}
            setOpenPastRadiology={setOpenPastRadiology}
          />
        </div>
      </div>
    </div>
  );
}

